import { type DateTimeLike, getRelativeTime } from '@racemap/utilities/functions/datetime';
import { Typography } from 'antd';
import type { TextProps } from 'antd/es/typography/Text';
import type { StringUnitLength } from 'luxon';
import { type CSSProperties, useState } from 'react';
import { useInterval } from 'src/lib/customHooks/useInterval';

type Props = {
  time: DateTimeLike | undefined | null;
  baseTime?: DateTimeLike;
  size?: StringUnitLength;
  textType?: TextProps['type'];
  fontSize?: CSSProperties['fontSize'];
  color?: CSSProperties['color'];
};

const { Text } = Typography;

export const RelativeTime: React.FC<Props> = ({
  time,
  baseTime,
  size = 'long',
  textType,
  fontSize,
  color,
}) => {
  const [relativeTime, setRelativeTime] = useState<string | null>();

  const updateRelativeTime = () => {
    if (time == null) {
      setRelativeTime(null);
      return;
    }
    const updatedRelativeTime = getRelativeTime(time, baseTime, size);
    setRelativeTime(updatedRelativeTime);
  };

  useInterval(async () => updateRelativeTime(), 1000);

  if (time == null || relativeTime == null) return null;

  return (
    <Text type={textType} style={{ fontSize, color }}>
      {relativeTime}
    </Text>
  );
};
